export const filterBanners = ({
  setTotalBanners,
  setCarouselList,
  banners = [],
  filters = {},
}) => {
  try {
    let filteredData = banners;

    if (filters?.activeBanners || filters?.path?.length || filters?.search) {
      filteredData = filteredData.filter((banner) => {
        let isValid = true;

        if (filters?.activeBanners && !banner?.isActive) {
          isValid = false;
        }

        if (filters?.path?.length && !filters?.path?.includes(banner?.path)) {
          isValid = false;
        }

        if (filters?.search) {
          const searchTerm = filters?.search.toLowerCase();
          const textFields = [
            banner?.altText,
            banner?.description?.en,
            banner?.name?.en,
            banner?.description?.hi,
            banner?.name?.hi,
          ];
          const searchMatch = textFields.some((field) =>
            field?.toLowerCase()?.includes(searchTerm)
          );
          if (!searchMatch) {
            isValid = false;
          }
        }

        return isValid;
      });
    }

    if (filters?.sortBy) {
      const sortProperty = filters?.sortBy.split(".");
      const order = filters?.order === "desc" ? -1 : 1;

      filteredData = filteredData.sort((a, b) => {
        const aVal = sortProperty.reduce((acc, key) => acc?.[key] ?? "", a);
        const bVal = sortProperty.reduce((acc, key) => acc?.[key] ?? "", b);

        if (typeof aVal === "string" && typeof bVal === "string") {
          return order * aVal.localeCompare(bVal);
        }

        return order * (aVal - bVal);
      });
    }

    const startIndex = filters?.pageNo * filters?.pageSize;
    const endIndex = (filters?.pageNo + 1) * filters?.pageSize;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    setTotalBanners(filteredData.length);
    setCarouselList(paginatedData);
  } catch (error) {
    console.error("Error updating banner list:", error);
  }
};
